import {
  Box,
  Checkbox,
  FormControlLabel,
  Grid,
  MenuItem,
  SelectChangeEvent,
} from "@mui/material";
import { useFormik } from "formik";
import React from "react";
import {
  ControlledCustomSelect,
  CustomFormLabel,
  CustomSelect,
  CustomTextField,
} from "../../../../../../../components/formsComponents";
import { renderDropdownValue } from "../../../../../../../helpers";
import {
  policyStatus,
} from "../../../../../../../constants/constants";
import {
  ILocationResponsePayload,
} from "../../../../../../../components/LocationAutoComplete/LocationAutoComplete";
import {
  CustomDatePicker,
} from "../../../../../../../components/formsComponents/CustomDatePicker";
import {
  useCustomerFullInfo,
  useCustomerPropspect,
  useDispatchWrapper,
  useFetchPolicies,
} from "../../../../../../../hooks";
import { useSelector } from "react-redux";
import { IStoreState } from "../../../../../../../redux/initialStoreState";
import { LabelCard } from "../../../../../../../components/LabelCard/LabelCard";
import {
  addLifeInsuranceCustomerInfoAsync,
  addLifeInsurancePolicyAdminAsync,
  addLifeInsurancePremiumAsync,
} from "../../../../../../../redux/lifeInsurancePolicy/lifeInsuranceBasicDetail/lifeInsuranceBasicDetailActions";
import { ILifeInsuranceCustomerInfo, initialLifeInsuranceBasicDetails } from "../../../../../../../redux/lifeInsurancePolicy/lifeInsuranceBasicDetail/lifeInsuranceBasicDetail.types";
import { MODULE_IDS, POLICIES } from "../../../../../../../constants/enums";
import { useNavigate } from "react-router-dom";
import { RoleBasedCustomButton } from "../../../../../../../security/RoleBasedComponents/RoleBasedCustomButton/RoleBasedCustomButton";
import { showMessage } from "../../../../../../../redux/messages/messagesActions";
import { AddressSearchAutoComplete } from "../../../../../../../components/AddressAutoComplete/AddressSearchAutoComplete";
import { LifeInsurancePolicyAdmin } from "../PolicyAdmin/PolicyAdmin";
import { isEqual } from "lodash";

export const LifeInsuranceCustomerInfo: React.FC<{
  customerId?: number;
  customerPolicyId?: number | null;
}> = (props) => {
  const { customerId, customerPolicyId } = props;
  const isUpdate = customerPolicyId ? true : false;
  const { policies, getPolicySubtypes } = useFetchPolicies();
  const customerFullDetails = useCustomerFullInfo();
  const customerProspect = useCustomerPropspect();
  const [saveLoading, setSaveLoading] = React.useState(false);
  const { customerInfo, policyAdmin: policyAdminState, premium: premiumState } = useSelector(
    (storeState: IStoreState) => storeState.lifeInsurance.basicDetails
  );

  const ComplianceCheckList = useSelector(
    (storeState: IStoreState) =>
      storeState.lifeInsurance.complianceCheckList.data
  );

  const dispatch = useDispatchWrapper();
  const navigate = useNavigate();
  const [buttonClicked, setButtonClicked] = React.useState<string | null>(null);
  const customerPolicyIdRef = React.useRef(customerPolicyId);
  const {
    values,
    handleChange,
    handleSubmit,
    setValues,
    setFieldValue,
    errors,
    submitForm,
  } = useFormik({
    initialValues: customerInfo.data,
    validate: (values) => {
      const errors: any = {};
      if (Number(values.sub_type) === 0) {
        errors.sub_type = "*Line of Business is required";
      } else if (!values.line_of_business) {
        errors.line_of_business = "*Line of Business is required";
      }
      return errors;
    },
    onSubmit: async (values: any) => {
      return new Promise((resolve, reject) => {
        setSaveLoading(true);
        dispatch(
          addLifeInsuranceCustomerInfoAsync(
            { ...values, customer_id: customerId },
            customerInfo.data,
            isUpdate,
            (isSuccess, policyId, error) => {
              if (error) {
                reject(error);
              }
              if (isSuccess && policyId) {
                customerPolicyIdRef.current = policyId;
                resolve(policyId);
              }
              // navigate(
              //   `/life-insurance-policy/${props.customerId}/basic-details/${policyId}`
              // );
              setSaveLoading(false);
            }
          )
        );
      });
    },
  });

   /**Policy Admin */

  const policyAdmin = useFormik({
    initialValues: initialLifeInsuranceBasicDetails["policyAdmin"]["data"],
    validate: (values) => {
      const errors: any = {};
      if (!values.advisor_one) {
        errors.advisor_one = "Advisor 1 is requried";
      }
      return errors;
    },
    onSubmit: async (values) => {
      return new Promise((resolve, reject) => {
        dispatch(
          addLifeInsurancePolicyAdminAsync(
            {
              ...values,
              customer_policy_id: customerPolicyIdRef.current as any,
            },
            (isSuccess, error) => {
              if (error) {
                reject(error);
              }
              resolve(isSuccess);
            }
          )
        );
      });
    },
  });

  /**Policy Premium */
  const formikPremium = useFormik({
    initialValues: initialLifeInsuranceBasicDetails["premium"]["data"],
    validate: (values) => {
      const errors: any = {};
      return errors;
    },
    onSubmit: async (values) => {
      return new Promise((resolve, reject) => {
        dispatch(
          addLifeInsurancePremiumAsync(
            {
              ...values,
              customer_policy_id: customerPolicyIdRef.current as any,
            },
            (isSuccess, error) => {
              if (error) {
                reject(error);
              }
              resolve(isSuccess);
            }
          )
        );
      });
    },
  });

  /**Handle Final Submit */
  const handleFinalSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    // Submit Premium form and wait for success callback
    try {
      let customPolicyCreation: any = true;
      let adminSubmitSuccess: any = true;
      let premiumSubmitSuccess: any = true;

      if (isUpdate) {
        // Only call APIs whose data has actually changed
        const customerInfoChanged = !isEqual(
          { ...values, customer_id: customerId },
          { ...customerInfo.data, customer_id: customerId }
        );
        const policyAdminChanged = !isEqual(
          { ...policyAdmin.values, customer_policy_id: customerPolicyIdRef.current },
          { ...policyAdminState.data, customer_policy_id: customerPolicyIdRef.current }
        );
        const premiumChanged = !isEqual(
          { ...formikPremium.values, customer_policy_id: customerPolicyIdRef.current },
          { ...premiumState.data, customer_policy_id: customerPolicyIdRef.current }
        );

        if (customerInfoChanged) {
          customPolicyCreation = await submitForm();
        }
        if (policyAdminChanged) {
          adminSubmitSuccess = await policyAdmin.submitForm();
        }
        if (premiumChanged) {
          premiumSubmitSuccess = await formikPremium.submitForm();
        }
      } else {
        customPolicyCreation = await submitForm();
        adminSubmitSuccess = await policyAdmin.submitForm();
        premiumSubmitSuccess = await formikPremium.submitForm();
      }

      // Check if all forms' API calls succeeded
      if (customPolicyCreation && adminSubmitSuccess && premiumSubmitSuccess) {
        navigate(
          `/life-insurance-policy/${customerId}/basic-details/${customerPolicyIdRef.current}`
          // `/life-insurance-policy/${props.customerId}/basic-details/${policyId}`
        );
        // if (buttonClicked === "saveAndNext") {
        //   changeStep(1);
        // }
        dispatch(
          showMessage({
            type: "success",
            message: "Customer policy information saved successfully!",
            displayAs: "snackbar",
          })
        );
      }
    } catch (error: any) {
      dispatch(
        showMessage({
          type: "error",
          message: error.response.data.message,
          displayAs: "snackbar",
        })
      );
    }
    finally {
      setSaveLoading(false); // Stop loading indicator
    }
  };

  const handleCheckBox =
    (key: keyof ILifeInsuranceCustomerInfo) =>
    (e: React.SyntheticEvent<Element>, checked: boolean) => {
      setFieldValue(key, checked);
    };

  const handleLineOfBusiness = (event: SelectChangeEvent<unknown>) => {
    setValues({
      ...values,
      line_of_business: event.target.value as string,
      sub_type: "",
    });
  };

  const handleAddress = (data: ILocationResponsePayload) => {
    setValues((prevValues: any) => ({
      ...prevValues, // Ensure previous state is maintained
      address: data.address,
      city: data.city,
      country: data.country,
      state: data.state,
      postal_code: data.postalCode,
    }));
  };

  React.useEffect(() => {
    if (!customerPolicyId && customerFullDetails) {
      setValues((prevValues: any) => ({
        ...prevValues,
        customer_code: customerProspect.data.customer_code,
        customer_name: customerProspect.data.customer_name,
        address: prevValues.address || customerProspect.data.mailing_address,
        state: prevValues.state || customerProspect.data.province_or_state,
        city: prevValues.city || customerProspect.data.city,
        postal_code: prevValues.postal_code || customerProspect.data.postal_code,
        country: prevValues.country || customerProspect.data.country,
        unit_or_suite: prevValues.unit_or_suite || customerProspect.data.unit_or_suite,
        language: prevValues.language || customerProspect.data.language,
        line_of_business: POLICIES.LIFE_AND_FINCANCIAL_POLICY,
      }));
    } else {
      setValues(customerInfo.data);
    }

     
  }, [customerInfo.data, customerProspect.data, customerPolicyId]);

  React.useEffect(() => {
    setFieldValue("compliance_status", ComplianceCheckList.compliance_status);
  }, [ComplianceCheckList]);

  return (
    <form onSubmit={handleFinalSubmit}>
      <Grid container spacing={1}>
        <Grid item xs={12} lg={2.4}>
          <CustomFormLabel>Life Insured</CustomFormLabel>
          <CustomTextField
            name="customer_name"
            variant="outlined"
            size="small"
            type="text"
            fullWidth
            value={values.customer_name}
            onChange={handleChange}
          />
        </Grid>

        <Grid item xs={12} lg={1.8}>
          <CustomFormLabel>Customer Code</CustomFormLabel>
          <CustomTextField
            name="customer_code"
            variant="outlined"
            size="small"
            type="text"
            fullWidth
            disabled
            value={values.customer_code}
          />
        </Grid>

        <Grid item xs={12} lg={1.8}>
          <CustomFormLabel>Language</CustomFormLabel>
          <ControlledCustomSelect
            fullWidth
            value={values.language}
            name="language"
            onChange={handleChange}
            placeholder="Select One"
            displayEmpty
            options={["E", "F"].map((template) => {
              return { label: template, value: template };
            })}
          ></ControlledCustomSelect>
        </Grid>

        <Grid item xs={12} lg={1.8}>
          <CustomFormLabel>Address Type</CustomFormLabel>
          <CustomSelect
            variant="outlined"
            size="small"
            type="string"
            name="address_type"
            fullWidth
            value={values.address_type}
            onChange={handleChange}
            displayEmpty
            renderValue={renderDropdownValue(`Select one`)}
          >
            {["R", "B"].map((transactionType) => {
              return (
                <MenuItem value={transactionType}>{transactionType}</MenuItem>
              );
            })}
          </CustomSelect>
        </Grid>

        <Grid item xs={12} lg={3.6}>
          <AddressSearchAutoComplete
            address={values.address}
            onAddressChange={handleAddress}
          />
        </Grid>

        <Grid item xs={12} lg={1.8}>
          <CustomFormLabel>Unit/Suite</CustomFormLabel>
          <CustomTextField
            id="unit_or_suite"
            variant="outlined"
            size="small"
            type="text"
            fullWidth
            value={values.unit_or_suite}
            onChange={handleChange}
          />
        </Grid>

        <Grid item xs={12} lg={1.8}>
          <CustomFormLabel>City</CustomFormLabel>
          <CustomTextField
            id="city"
            variant="outlined"
            size="small"
            type="text"
            fullWidth
            value={values.city}
            onChange={handleChange}
          />
        </Grid>

        <Grid item xs={12} lg={1.8}>
          <CustomFormLabel>State/Province</CustomFormLabel>
          <CustomTextField
            id="state"
            variant="outlined"
            size="small"
            type="text"
            fullWidth
            value={values.state}
            onChange={handleChange}
          />
        </Grid>

        <Grid item xs={12} lg={1.2}>
          <CustomFormLabel>Postal Code</CustomFormLabel>
          <CustomTextField
            id="postal_code"
            variant="outlined"
            size="small"
            type="text"
            fullWidth
            value={values.postal_code}
            onChange={handleChange}
          />
        </Grid>

        <Grid item xs={12} lg={1.8}>
          <CustomFormLabel>Country</CustomFormLabel>
          <CustomTextField
            id="country"
            variant="outlined"
            size="small"
            type="text"
            fullWidth
            value={values.country}
            onChange={handleChange}
          />
        </Grid>
      </Grid>

      <LabelCard heading="Policy Information" />

      <Grid container spacing={1}>
        <Grid item xs={12} lg={2.4}>
          <CustomFormLabel>Policy Status</CustomFormLabel>
          <CustomSelect
            variant="outlined"
            size="small"
            type="string"
            fullWidth
            name="policy_status"
            value={values.policy_status}
            onChange={handleChange}
            displayEmpty
            renderValue={renderDropdownValue(`Select one`)}
          >
            {policyStatus.map((status) => {
              return <MenuItem value={status}>{status}</MenuItem>;
            })}
          </CustomSelect>
        </Grid>

        <Grid item xs={12} lg={2.4}>
          <CustomFormLabel>Policy Number</CustomFormLabel>
          <CustomTextField
            name="policy_number"
            variant="outlined"
            size="small"
            type="text"
            fullWidth
            value={values.policy_number}
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={12} lg={2.4}>
          <CustomFormLabel>Policy Term</CustomFormLabel>
          <ControlledCustomSelect
            variant="outlined"
            size="small"
            type="string"
            name="policy_term"
            fullWidth
            value={values.policy_term}
            onChange={handleChange}
            displayEmpty
            placeholder="Select One"
            options={["T10", "T15", "T20", "T25", "T30", "T35", "T40", "T100", "L10", "L20", "L65", "L100", "Custom Term"].map((term) => {
              return { label: term, value: term };
            })}
          ></ControlledCustomSelect>
           
        </Grid>

        <Grid item xs={12} lg={2.4}>
          <CustomFormLabel>Effective Date</CustomFormLabel>
          <CustomDatePicker
            fullWidth
            value={values.effective_date || ""}
            onChange={(newValue) => {
              setFieldValue("effective_date", newValue);
            }}
          />
        </Grid>

        <Grid item xs={12} lg={2.4}>
          <CustomFormLabel>Expiry Date</CustomFormLabel>
          <CustomDatePicker
            fullWidth
            value={values.expiry_date || ""}
            onChange={(newValue) => {
              setFieldValue("expiry_date", newValue);
            }}
          />
        </Grid>

        <Grid item xs={12} lg={2.4}>
          <CustomFormLabel>Policy Limit</CustomFormLabel>
          <CustomTextField
            name="policy_limit"
            variant="outlined"
            size="small"
            type="text"
            fullWidth
            value={values.policy_limit}
            onChange={handleChange}
          />
        </Grid>

        <Grid item xs={12} lg={2.4}>
          <CustomFormLabel>Policy Type</CustomFormLabel>
          <CustomSelect
            variant="outlined"
            size="small"
            type="string"
            name="line_of_business"
            fullWidth
            value={values.line_of_business}
            onChange={handleLineOfBusiness}
            disabled
            displayEmpty
            renderValue={renderDropdownValue(`Select one`)}
            error={Boolean(errors.line_of_business)}
          >
            {policies.map((policy) => {
              return <MenuItem value={policy.type}>{policy.type}</MenuItem>;
            })}
          </CustomSelect>
        </Grid>

        <Grid item xs={12} lg={2.4}>
          <CustomFormLabel>Line of Business</CustomFormLabel>
          <ControlledCustomSelect
            variant="outlined"
            size="small"
            type="string"
            name="sub_type"
            fullWidth
            value={Number(values.sub_type)}
            onChange={handleChange}
            displayEmpty
            placeholder="Select One"
            // helperText={errors.sub_type}
            options={getPolicySubtypes(values.line_of_business || "").map(
              (item) => {
                return { label: item.name, value: item.policy_id };
              }
            )}
            error={Boolean(errors.sub_type)}
          ></ControlledCustomSelect>
        </Grid>

        {values.policy_status === "Cancelled" && (
          <>
            <Grid item xs={12} lg={2.4}>
              <CustomFormLabel>Date Cancelled</CustomFormLabel>
              <CustomDatePicker
                fullWidth
                value={values.date_cancelled || ""}
                onChange={(newValue) => {
                  setFieldValue("date_cancelled", newValue);
                }}
              />
            </Grid>
          </>
        )}

        <Grid item xs={12} md={12}>
          <LifeInsurancePolicyAdmin
            customerpolicyId={customerPolicyId}
            policyAdmin={policyAdmin}
            policyPremimum={formikPremium}
          />
        </Grid>

        <Grid item xs={12} md={12}>
          <LabelCard heading="Preferences" />
        </Grid>

        <Grid container spacing={1}>
          <Grid item xs={12} lg={4}>
            <FormControlLabel
              labelPlacement="end"
              onChange={handleCheckBox(
                "Send_Invoices_Renewal_Recievable_By_Email"
              )}
              control={
                <Checkbox
                  checked={
                    values.Send_Invoices_Renewal_Recievable_By_Email || false
                  }
                />
              }
              label="Send Invoices , Renewal , Receivable By Email"
              sx={{ m: 0, fontSize: 15 }}
            />
          </Grid>

          <Grid item xs={12} lg={4}>
            <FormControlLabel
              labelPlacement="end"
              onChange={handleCheckBox("Send_Statement_By_Email")}
              control={
                <Checkbox
                  name="Send_Statement_By_Email"
                  checked={values.Send_Statement_By_Email || false}
                />
              }
              label="Send Statement By Email"
              sx={{ m: 0, fontSize: 15 }}
            />
          </Grid>

          <Grid item xs={12} lg={4}>
            <FormControlLabel
              labelPlacement="end"
              onChange={handleCheckBox("Send_docs_By_Email")}
              control={
                <Checkbox
                  name="Send_docs_By_Email"
                  checked={values.Send_docs_By_Email || false}
                />
              }
              label="Send Docs By Email"
              sx={{ m: 0, fontSize: 15 }}
            />
          </Grid>
        </Grid>
      </Grid>

      <Box sx={{ mt: 2 }}>
        <RoleBasedCustomButton
          moduleKey={MODULE_IDS.LIFE_AND_FINCANCIAL}
          type="submit"
          disabled={saveLoading}
          variant="contained"
        >
          Save
        </RoleBasedCustomButton>
      </Box>
    </form>
  );
};
